import { styled } from '@/stitches.config';

import { TableCell, TableRow } from '../../../atoms';

export const StyledTableBodyRow = styled(TableRow, {
  color: '$charcoal300',
});

export const StyledTableBodyCell = styled(TableCell, {
  border: '$0',
});
